<template>
  <div id="app">
    <v-app id="inspire">
      <v-content style="height: 100%">
          <v-layout align-center >
            <v-flex>
              <v-card dark>
                <div align="center">
                  <br>
                  <br>
                  <br>
                <img src="../../assets/logo.png">
                  <br>
                  <br>
                  <br>
                  <br>
                </div>
                <v-card-text>
                  <v-form>
                    <v-layout>
                      <v-flex xs11 sm8 offset-sm2>
                        <v-text-field prepend-icon="person" name="Username" label="Usuario" v-model="username"></v-text-field>
                        <v-text-field prepend-icon="lock" name="Password" label="Password" type="password" v-model="password"
                                      :append-icon="show ? 'visibility_off' : 'visibility'"
                                      @click:append="() => (show = !show)"
                                      :type="show ? 'text' : 'password'"
                                      v-on:keyup.enter="login"></v-text-field>
                        <p v-if="this.$store.state.errorLogin"  class="text-sm-center warning--text" color="cyan darken-1">Usuario o contraseña incorrectos</p>
                        <div align="center"><a @click="openDialogRequestPasswordReset" @click.stop="dialogPassword = true">¿Olvidó su contraseña?</a></div>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
                <v-card-actions>


                  <v-layout>
                    <v-flex>
                      <div align="center">
                      <v-btn color="primary" class="btn-rounded" large block v-on:click="login" >Entrar</v-btn>
                      </div>
                    </v-flex>
                  </v-layout>

                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>

                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
          <!--MODAL PARA INGRESAR EL CORREO Y RECUPERAR LA CONTRASEÑA.-->
          <v-dialog v-model="dialogPassword" max-width="500px">-->
            <v-card>
              <div>
                <div class="headline">
                  <v-card-title primary-title>Recuperar Contraseña</v-card-title>
                </div>
              </div>
              <v-card-text>
                <v-form v-model="valid">
                  Ingrese su correo electrónico para recuperar su contraseña
                  <v-text-field prepend-icon="email" :rules="emailRules" name="Correo electrónico" label="Correo electrónico" v-model="mailResetPassword"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="grey darken-4" flat  :disabled="!valid" @click="requestPasswordReset">Enviar</v-btn>
                <v-btn color="grey darken-1" flat @click.stop="dialogPassword=false">Cancelar</v-btn>
              </v-card-actions>
            </v-card>
            <v-alert v-model="alert" color="error" dismissible>{{error}}</v-alert>
          </v-dialog>
      </v-content>
    </v-app>
  </div>
</template>

<script>
  export default {
    name: 'Login',
    data () {
      return {
        valid:false,
        show: false,
        username: '',
        password: '',
        mailResetPassword: '',
        dialogPassword: false,
        dialogPasswordSuccess: false,
        error: "",
        alert: false,
        emailRules: [
          v => !!v || 'El email es requerido',
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El email debe ser valido'
        ],
      }
    },
    methods: {
      login () {
        this.$router.push('/menuMovil');
      },
      openDialogRequestPasswordReset(){
        this.error= ""
        this.alert= false
        this.mailResetPassword= ""
      },
      requestPasswordReset () {
        if(this.checkFormResetPassword()){
          this.$store.dispatch('requestPasswordReset', {mail: this.mailResetPassword, host: 'admin'}).then(response => {
          })
        }
        this.dialogPassword = false
      },
      cancelar(){
        this.username=""
        this.password=""
      },
      checkFormResetPassword(){
        if(this.mailResetPassword===""){
          this.error= "Debe ingresar el usuario para recuperar la contraseña"
          this.alert=true
          return false
        }
        return true
      }
    }
  }
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/LoginMovil.vue